export const LETTERS_ONLY_REGEXP =  /^[a-zA-Z]*$/
export const DIGITS_ONLY_REGEXP =  /^[0-9]*$/
export const LETTERS_AND_DIGITS_ONLY_REGEXP =  /^[0-9a-zA-Z]*$/
export const LETTERS_NUMBERS_SYMBOLS_SPACES_REGEXP = /^[A-Za-z0-9\s\-!$%^&*()_+|~=\\`{}\[\]:";'<>?,.\/#@№“]+$/u
